module.exports = __webpack_public_path__ + "static/Drake-78f2e84c20028c4aaa9ddc0c1d030ffc.jpeg";